import React, { useEffect, useState } from 'react';
import HomeCarousel from '../../components/Carousel/Carousel';
import { Navbar } from '../../components/Navbar/Navbar';
import { Card, CardContent, Container, Grid, List, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNewsData } from '../../Actions/News';
import Ticker from 'react-ticker';
import ChatBot from '../../components/ChatBot/ChatBot';
import Tickers from '../../components/Tickers/Tickers';
import Footer from '../../components/Footer/Footer';
import axios from 'axios';
import { getUpdates } from '../../API/api';
// const API = axios.create({
//   baseURL: 'http://localhost:5000',
// });
const API = axios.create({
  baseURL: 'https://uwp.srmist.edu.in/be',
});
const HomePage = () => {
  const [image, setImage] = useState([]);
  const [newsInfo, setnewsInfo] = useState([]);

  const dispatch = useDispatch();
  const newsdata = useSelector(state => state.newsData);

  useEffect(() => {
    API.get('/admin/getSliderImage').then(res => {
      // console.log(res.data);
    });
  }, []);

  useEffect(() => {
    dispatch(fetchNewsData());
  }, [dispatch]);

  useEffect(() => {
    newsdata?.newsData?.data && setnewsInfo(newsdata?.newsData?.data);

  }, [newsdata]);

  const [updateInfo, setUpdateInfo] = useState([]);

  const getData = async () => {
    axios
      .get(getUpdates)
      .then(response => {
        setUpdateInfo(response?.data?.data);
        console.log(updateInfo)
      })
      .catch(error => {
        console.log(error);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  // console.log(newsdata);

  return (
    <div>
      {/* <ChatBot/> */}
      <Navbar />

      <div className='mb-10 mt-10 flex flex-col justify-center lg:p-16 p-[1rem]  py-5 lg:flex-row h-[125vh] lg:gap-20 gap-[3rem]'>
        <div className='flex flex-col gap-20 '>
          <HomeCarousel />
          <div className='flex flex-col w-full'>
            {/* item md={3} sm={12} xs={12} sx={{ justifyContent: 'Center', marginLeft: [1, 1, 5], marginTop: '20px' }}> */}
            <p className='text-[#62392B] font-bold text-lg lg:text-2xl font-[Sora]'>
              NEWS
            </p>
            <ul className='flex flex-row overflow-x-scroll '

            >
              {newsInfo?.map(data => (
                <li>
                  <div className='w-80 '

                  >
                    <div className='w-64'>
                      <p className='text-[#ff7345] text-justify text-lg font-[Sora]'>{data.title}</p>
                      <p className='text-[#62392b] font-[poppins] pt-2 text-justify font-[400] text-sm'
                      >
                        {data.description}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className='flex mt-1 flex-col'>
          <p className='font-[Sora] text-[#62392b] font-bold text-xl lg:text-2xl'>
            UPDATES
          </p>
          <ul className='flex sm:flex-row overflow-x-scroll lg:overflow-y-scroll lg:flex-col gap-4 h-[30vh] lg:h-[120vh] '>
            {updateInfo?.slice(0).reverse().map(data => (
              <li className='w-80'>
                {/* data.link */}
                <p className='text-[#ff7345] font-[Sora]'><a href={data.docURL}>{data.title}</a ></p>
                <p className='text-[#62392B] text-sm font-[Sora] pt-4 font-[400] overflow-y-scroll h-[20vh] lg:h-[25vh]'>
                  {data.description}
                </p>


              </li>
            ))}
          </ul>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default HomePage;
